export const GET_SUBSCRIPTION_SETUP_START = 'GET_SUBSCRIPTION_SETUP_START';
export const GET_SUBSCRIPTION_SETUP_SUCCESS = 'GET_SUBSCRIPTION_SETUP_SUCCESS';
export const GET_SUBSCRIPTION_SETUP_FAILED = 'GET_SUBSCRIPTION_SETUP_FAILED';

export const UPDATE_SUBSCRIPTION_SETUP_START = 'UPDATE_SUBSCRIPTION_SETUP_START';
export const UPDATE_SUBSCRIPTION_SETUP_SUCCESS = 'UPDATE_SUBSCRIPTION_SETUP_SUCCESS';
export const UPDATE_SUBSCRIPTION_SETUP_FAILED = 'UPDATE_SUBSCRIPTION_SETUP_FAILED';

export const GET_ADDITIONAL_SKUS_START = 'GET_ADDITIONAL_SKUS_START';
export const GET_ADDITIONAL_SKUS_SUCCESS = 'GET_ADDITIONAL_SKUS_SUCCESS';
export const GET_ADDITIONAL_SKUS_FAILED = 'GET_ADDITIONAL_SKUS_FAILED';

export const CREATE_ADDITIONAL_SKUS_START = 'CREATE_ADDITIONAL_SKUS_START';
export const CREATE_ADDITIONAL_SKUS_SUCCESS = 'CREATE_ADDITIONAL_SKUS_SUCCESS';
export const CREATE_ADDITIONAL_SKUS_FAILED = 'CREATE_ADDITIONAL_SKUS_FAILED';

export const EDIT_ADDITIONAL_SKUS_START = 'EDIT_ADDITIONAL_SKUS_START';
export const EDIT_ADDITIONAL_SKUS_SUCCESS = 'EDIT_ADDITIONAL_SKUS_SUCCESS';
export const EDIT_ADDITIONAL_SKUS_FAILED = 'EDIT_ADDITIONAL_SKUS_FAILED';

export const DELETE_ADDITIONAL_SKUS_START = 'DELETE_ADDITIONAL_SKUS_START';
export const DELETE_ADDITIONAL_SKUS_SUCCESS = 'DELETE_ADDITIONAL_SKUS_SUCCESS';
export const DELETE_ADDITIONAL_SKUS_FAILED = 'DELETE_ADDITIONAL_SKUS_FAILED';

export const GET_ADDITIONAL_SPECIALS_START = 'GET_ADDITIONAL_SPECIALS_START';
export const GET_ADDITIONAL_SPECIALS_SUCCESS = 'GET_ADDITIONAL_SPECIALS_SUCCESS';
export const GET_ADDITIONAL_SPECIALS_FAILED = 'GET_ADDITIONAL_SPECIALS_FAILED';

export const CREATE_ADDITIONAL_SPECIALS_START = 'CREATE_ADDITIONAL_SPECIALS_START';
export const CREATE_ADDITIONAL_SPECIALS_SUCCESS = 'CREATE_ADDITIONAL_SPECIALS_SUCCESS';
export const CREATE_ADDITIONAL_SPECIALS_FAILED = 'CREATE_ADDITIONAL_SPECIALS_FAILED';

export const EDIT_ADDITIONAL_SPECIALS_START = 'EDIT_ADDITIONAL_SPECIALS_START';
export const EDIT_ADDITIONAL_SPECIALS_SUCCESS = 'EDIT_ADDITIONAL_SPECIALS_SUCCESS';
export const EDIT_ADDITIONAL_SPECIALS_FAILED = 'EDIT_ADDITIONAL_SPECIALS_FAILED';

export const DELETE_ADDITIONAL_SPECIALS_START = 'DELETE_ADDITIONAL_SPECIALS_START';
export const DELETE_ADDITIONAL_SPECIALS_SUCCESS = 'DELETE_ADDITIONAL_SPECIALS_SUCCESS';
export const DELETE_ADDITIONAL_SPECIALS_FAILED = 'DELETE_ADDITIONAL_SPECIALS_FAILED';

export const GET_ADDITIONAL_FEATURES_START = 'GET_ADDITIONAL_FEATURES_START';
export const GET_ADDITIONAL_FEATURES_SUCCESS = 'GET_ADDITIONAL_FEATURES_SUCCESS';
export const GET_ADDITIONAL_FEATURES_FAILED = 'GET_ADDITIONAL_FEATURES_FAILED';

export const CREATE_ADDITIONAL_FEATURES_START = 'CREATE_ADDITIONAL_FEATURES_START';
export const CREATE_ADDITIONAL_FEATURES_SUCCESS = 'CREATE_ADDITIONAL_FEATURES_SUCCESS';
export const CREATE_ADDITIONAL_FEATURES_FAILED = 'CREATE_ADDITIONAL_FEATURES_FAILED';

export const EDIT_ADDITIONAL_FEATURES_START = 'EDIT_ADDITIONAL_FEATURES_START';
export const EDIT_ADDITIONAL_FEATURES_SUCCESS = 'EDIT_ADDITIONAL_FEATURES_SUCCESS';
export const EDIT_ADDITIONAL_FEATURES_FAILED = 'EDIT_ADDITIONAL_FEATURES_FAILED';

export const DELETE_ADDITIONAL_FEATURES_START = 'DELETE_ADDITIONAL_FEATURES_START';
export const DELETE_ADDITIONAL_FEATURES_SUCCESS = 'DELETE_ADDITIONAL_FEATURES_SUCCESS';
export const DELETE_ADDITIONAL_FEATURES_FAILED = 'DELETE_ADDITIONAL_FEATURES_FAILED';

export const CREATE_MARKETING_BILLING_START = 'CREATE_MARKETING_BILLING_START';
export const CREATE_MARKETING_BILLING_SUCCESS = 'CREATE_MARKETING_BILLING_SUCCESS';
export const CREATE_MARKETING_BILLING_FAILED = 'CREATE_MARKETING_BILLING_FAILED';

export const BILL_STORE_FROM_ONBOARDING_START = 'BILL_STORE_FROM_ONBOARDING_START';
export const BILL_STORE_FROM_ONBOARDING_SUCCESS = 'BILL_STORE_FROM_ONBOARDING_SUCCESS';
export const BILL_STORE_FROM_ONBOARDING_FAILED = 'BILL_STORE_FROM_ONBOARDING_FAILED';

export const CHANGE_MARKETING_DATA = 'CHANGE_MARKETING_DATA';
export const SAVE_MARKETING_DATA_START = 'SAVE_MARKETING_DATA_START';
export const SAVE_MARKETING_DATA_SUCCESS = 'SAVE_MARKETING_DATA_SUCCESS';
export const SAVE_MARKETING_DATA_FAILED = 'SAVE_MARKETING_DATA_FAILED';

export const CHANGE_ONBOARDING_DATA = 'CHANGE_ONBOARDING_DATA';
export const SAVE_ONBOARDING_DATA_START = 'SAVE_ONBOARDING_DATA_START';
export const SAVE_ONBOARDING_DATA_SUCCESS = 'SAVE_ONBOARDING_DATA_SUCCESS';
export const SAVE_ONBOARDING_DATA_FAILED = 'SAVE_ONBOARDING_DATA_FAILED';

export const GET_SUBSCRIPTION_BENEFITS_START = 'GET_SUBSCRIPTION_BENEFITS_START';
export const GET_SUBSCRIPTION_BENEFITS_SUCCESS = 'GET_SUBSCRIPTION_BENEFITS_SUCCESS';
export const GET_SUBSCRIPTION_BENEFITS_FAILED = 'GET_SUBSCRIPTION_BENEFITS_FAILED';
export const CREATE_SUBSCRIPTION_BENEFIT_START = 'CREATE_SUBSCRIPTION_BENEFIT_START';
export const CREATE_SUBSCRIPTION_BENEFIT_SUCCESS = 'CREATE_SUBSCRIPTION_BENEFIT_SUCCESS';
export const CREATE_SUBSCRIPTION_BENEFIT_FAILED = 'CREATE_SUBSCRIPTION_BENEFIT_FAILED';
export const UPDATE_SUBSCRIPTION_BENEFIT_START = 'UPDATE_SUBSCRIPTION_BENEFIT_START';
export const UPDATE_SUBSCRIPTION_BENEFIT_SUCCESS = 'UPDATE_SUBSCRIPTION_BENEFIT_SUCCESS';
export const UPDATE_SUBSCRIPTION_BENEFIT_FAILED = 'UPDATE_SUBSCRIPTION_BENEFIT_FAILED';
export const DELETE_SUBSCRIPTION_BENEFIT_START = 'DELETE_SUBSCRIPTION_BENEFIT_START';
export const DELETE_SUBSCRIPTION_BENEFIT_SUCCESS = 'DELETE_SUBSCRIPTION_BENEFIT_SUCCESS';
export const DELETE_SUBSCRIPTION_BENEFIT_FAILED = 'DELETE_SUBSCRIPTION_BENEFIT_FAILED';

export const getSubscriptionSetupStart = () => ({
  type: GET_SUBSCRIPTION_SETUP_START
});

export const getSubscriptionSetupSuccess = (data) => ({
  type: GET_SUBSCRIPTION_SETUP_SUCCESS,
  data
});

export const getSubscriptionSetupFailed = (error) => ({
  type: GET_SUBSCRIPTION_SETUP_FAILED,
  error
});

export const updateSubscriptionSetupStart = () => ({
  type: UPDATE_SUBSCRIPTION_SETUP_START
});

export const updateSubscriptionSetupSuccess = (data) => ({
  type: UPDATE_SUBSCRIPTION_SETUP_SUCCESS,
  data
});

export const updateSubscriptionSetupFailed = (error) => ({
  type: UPDATE_SUBSCRIPTION_SETUP_FAILED,
  error
});

export const getAdditionalSkusStart = () => ({
  type: GET_ADDITIONAL_SKUS_START
});

export const getAdditionalSkusSuccess = (data) => ({
  type: GET_ADDITIONAL_SKUS_SUCCESS,
  data
});

export const getAdditionalSkusFailed = (error) => ({
  type: GET_ADDITIONAL_SKUS_FAILED,
  error
});

export const createAdditionalSkusStart = () => ({
  type: CREATE_ADDITIONAL_SKUS_START
});

export const createAdditionalSkusSucces = (data) => ({
  type: CREATE_ADDITIONAL_SKUS_SUCCESS,
  data
});

export const createAdditionalSkusFailed = (error) => ({
  type: CREATE_ADDITIONAL_SKUS_FAILED,
  error
});

export const editAdditionalSkusStart = () => ({
  type: EDIT_ADDITIONAL_SKUS_START
});

export const editAdditionalSkusSuccess = (data) => ({
  type: EDIT_ADDITIONAL_SKUS_SUCCESS,
  data
});

export const editAdditionalSkusFailed = (error) => ({
  type: EDIT_ADDITIONAL_SKUS_FAILED,
  error
});

export const deleteAdditionalSkusStart = () => ({
  type: DELETE_ADDITIONAL_SKUS_START
});

export const deleteAdditionalSkusSuccess = (data) => ({
  type: DELETE_ADDITIONAL_SKUS_SUCCESS,
  data
});

export const deleteAdditionalSkusFailed = (error) => ({
  type: DELETE_ADDITIONAL_SKUS_FAILED,
  error
});

export const getAdditionalSpecialsStart = () => ({
  type: GET_ADDITIONAL_SPECIALS_START
});

export const getAdditionalSpecialsSuccess = (data) => ({
  type: GET_ADDITIONAL_SPECIALS_SUCCESS,
  data
});

export const getAdditionalSpecialsFailed = (error) => ({
  type: GET_ADDITIONAL_SPECIALS_FAILED,
  error
});

export const createAdditionalSpecialsStart = () => ({
  type: CREATE_ADDITIONAL_SPECIALS_START,
});

export const createAdditionalSpecialsSuccess = (data) => ({
  type: CREATE_ADDITIONAL_SPECIALS_SUCCESS,
  data
});

export const createAdditionalSpecialsFailed = (error) => ({
  type: CREATE_ADDITIONAL_SPECIALS_FAILED,
  error
});

export const editAdditionalSpecialsStart = () => ({
  type: EDIT_ADDITIONAL_SPECIALS_START
});

export const editAdditionalSpecialsSuccess = (data) => ({
  type: EDIT_ADDITIONAL_SPECIALS_SUCCESS,
  data
});

export const editAdditionalSpecialsFailed = (error) => ({
  type: EDIT_ADDITIONAL_SPECIALS_FAILED,
  error
});

export const deleteAdditionalSpecialsStart = () => ({
  type: DELETE_ADDITIONAL_SPECIALS_START
});

export const deleteAdditionalSpecialsSuccess = (data) => ({
  type: DELETE_ADDITIONAL_SPECIALS_SUCCESS,
  data
});

export const deleteAdditionalSpecialsFailed = (error) => ({
  type: DELETE_ADDITIONAL_SPECIALS_FAILED,
  error
});

export const getAdditionalFeaturesStart = () => ({
  type: GET_ADDITIONAL_FEATURES_START
});

export const getAdditionalFeaturesSuccess = (data) => ({
  type: GET_ADDITIONAL_FEATURES_SUCCESS,
  data
});

export const getAdditionalFeaturesFailed = (error) => ({
  type: GET_ADDITIONAL_FEATURES_FAILED,
  error
});

export const createAdditionalFeaturesStart = () => ({
  type: CREATE_ADDITIONAL_FEATURES_START
});

export const createAdditionalFeaturesSuccess = (data) => ({
  type: CREATE_ADDITIONAL_FEATURES_SUCCESS,
  data
});

export const createAdditionalFeaturesFailed = (error) => ({
  type: CREATE_ADDITIONAL_FEATURES_FAILED,
  error
});

export const editAdditionalFeaturesStart = () => ({
  type: EDIT_ADDITIONAL_FEATURES_START
});

export const editAdditionalFeaturesSuccess = (data) => ({
  type: EDIT_ADDITIONAL_FEATURES_SUCCESS,
  data
});

export const editAdditionalFeaturesFailed = (error) => ({
  type: EDIT_ADDITIONAL_FEATURES_FAILED,
  error
});

export const deleteAdditionalFeaturesStart = () => ({
  type: DELETE_ADDITIONAL_FEATURES_START
});

export const deleteAdditionalFeaturesSuccess = (data) => ({
  type: DELETE_ADDITIONAL_FEATURES_SUCCESS,
  data
});

export const deleteAdditionalFeaturesFailed = (error) => ({
  type: DELETE_ADDITIONAL_FEATURES_FAILED,
  error
});

export const createMarketingBillingStart = () => ({
  type: CREATE_MARKETING_BILLING_START,
});

export const createMarketingBillingSuccess = (data) => ({
  type: CREATE_MARKETING_BILLING_SUCCESS,
  data
});

export const createMarketingBillingFailed = (error) => ({
  type: CREATE_MARKETING_BILLING_FAILED,
  error
});

export const billStoreFromOnboardingStart = () => ({
  type: BILL_STORE_FROM_ONBOARDING_START
});

export const billStoreFromOnboardingSuccess = (data) => ({
  type: BILL_STORE_FROM_ONBOARDING_SUCCESS,
  data
});

export const billStoreFromOnboardingFailed = (error) => ({
  type: BILL_STORE_FROM_ONBOARDING_FAILED,
  error
});

export const changeOnboardingData = (data) => ({
  type: CHANGE_ONBOARDING_DATA,
  data
});
export const saveOnboardingDataStart = () => ({
  type: SAVE_ONBOARDING_DATA_START
});
export const saveOnboardingDataSuccess = (data) => ({
  type: SAVE_ONBOARDING_DATA_SUCCESS,
  data
});
export const saveOnboardingDataFailed = (error) => ({
  type: SAVE_ONBOARDING_DATA_FAILED,
  error
});

export const changeMarketingData = (data) => ({
  type: CHANGE_MARKETING_DATA,
  data
});
export const saveMarketingDataStart = () => ({
  type: SAVE_MARKETING_DATA_START
});

export const saveMarketingDataSuccess = (data) => ({
  type: SAVE_MARKETING_DATA_SUCCESS,
  data
});

export const saveMarketingDataFailed = (error) => ({
  type: SAVE_MARKETING_DATA_FAILED,
  error
});

export const getSubscriptionBenefitsStart = () => ({
  type: GET_SUBSCRIPTION_BENEFITS_START
});

export const getSubscriptionBenefitsSuccess = (data) => ({
  type: GET_SUBSCRIPTION_BENEFITS_SUCCESS,
  data
});

export const getSubscriptionBenefitsFailed = (error) => ({
  type: GET_SUBSCRIPTION_BENEFITS_FAILED,
  error
});

export const createSubscriptionBenefitStart = () => ({
  type: CREATE_SUBSCRIPTION_BENEFIT_START
});

export const createSubscriptionBenefitSuccess = (data) => ({
  type: CREATE_SUBSCRIPTION_BENEFIT_SUCCESS,
  data
});

export const createSubscriptionBenefitFailed = (error) => ({
  type: CREATE_SUBSCRIPTION_BENEFIT_FAILED,
  error
});

export const updateSubscriptionBenefitStart = () => ({
  type: UPDATE_SUBSCRIPTION_BENEFIT_START
});

export const updateSubscriptionBenefitSuccess = (data) => ({
  type: UPDATE_SUBSCRIPTION_BENEFIT_SUCCESS,
  data
});

export const updateSubscriptionBenefitFailed = (error) => ({
  type: UPDATE_SUBSCRIPTION_BENEFIT_FAILED,
  error
});

export const deleteSubscriptionBenefitStart = () => ({
  type: DELETE_SUBSCRIPTION_BENEFIT_START
});

export const deleteSubscriptionBenefitSuccess = (item, data) => ({
  type: DELETE_SUBSCRIPTION_BENEFIT_SUCCESS,
  item,
  data
});

export const deleteSubscriptionBenefitFailed = (error) => ({
  type: DELETE_SUBSCRIPTION_BENEFIT_FAILED,
  error
});
